import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Container, Image, Spinner, Table } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { isLoggin } from '../service/LoginService';
import RegistOrLogin from './RegistOrLogin';
import DynamicDialog from './DynamicDialog';
import UserMark from './UserMark';
import { LoginInfo } from '../App';

const Company = () => {
	async function getTerms(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/terms").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function checkout(plan){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/checkout/subscribe/"+plan).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const {t,i18n} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [checkoutProcess,setCheckoutProcess] = useState(false)
    const [showDialog,setShowDialog] = useState(false)
    const [title,setTitle] = useState("")
    const [message,setMessage] = useState("")
    function dialog(title,message){
        setTitle(title)
        setMessage(message)
        setShowDialog(true)
    }

	useEffect(() => {
		document.querySelector("title").textContent = "会社概要 - アワート合同会社"
	},[location.pathname])

    function checkoutProcessHandler(plan){
        setCheckoutProcess(true)
        isLoggin().then(r => {
            if(r.result){
                checkout(plan).then(r => {
                    if(r.result){
                        window.location.href = r.data.url
                    } else {
                        dialog("",r.errors)
                        setCheckoutProcess(false)
                    }
                })
            } else {
                dialog(t("common.loginToContinue"),<RegistOrLogin />)
                setCheckoutProcess(false)
            }
        })
    }

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Category />
        <Image src='/img/ad_ourt.webp' style={{position:"fixed",width:"100%",opacity:0.2,zIndex:-1}} />
        <Dialog show={showDialog} title="" message={message} handleClose={() => setShowDialog(false)} />
        <Container>
            <Container className='text-center'>
                {loginInfo.result === undefined ? "" : (<>
                    {loginInfo.kawaii_mode === 1 ? <span className="App-logo" id="logo" style={{fontSize:"70px",cursor:"pointer"}}>kawaii</span> : (
                    <Link to="/" style={{textDecoration:"none",color: "#000000"}}><span className="App-logo" id="logo" style={{fontSize:"70px",cursor:"pointer"}}><img src='/img/ourt_logo_dashed.png' height={70} /></span></Link>
                    )}
                    </>
                )}
            </Container>
            <h3 style={{fontWeight:"normal",fontFamily:"Meityo UI"}} className='mb-3'>会社概要</h3>
            <Table striped>
                <tbody>
                    <tr><th>会社名</th><td>アワート合同会社</td></tr>
                    <tr><th>会社名(英語表記)</th><td>ourt LLC</td></tr>
                    <tr><th>法人番号</th><td><Link to={"https://www.houjin-bangou.nta.go.jp/henkorireki-johoto.html?selHouzinNo=9010003042765"}>9010003042765</Link></td></tr>
                    <tr><th>サービス開始日</th><td>2022年8月24日</td></tr>
                    <tr><th>会社設立日</th><td>2024年1月23日</td></tr>
                    <tr><th>決算月</th><td>12月</td></tr>
                    <tr><th>代表者</th><td>元水 稜真</td></tr>
                    <tr><th>所在地</th><td>〒101-0024 東京都千代田区神田和泉町1番地6-16ヤマトビル405</td></tr>
                    <tr><th>電話番号</th><td>090-8835-2738 ※サービスについてのお問い合わせはその他の連絡先から行ってください。</td></tr>
                    <tr><th>その他の連絡先</th><td>
                        <Link to="https://twitter.com/ourt_ai">X(旧Twitter)</Link><br />
                        <Link to="https://discord.gg/646h4vFMv2">Discord</Link><br />
                        <Link to="https://lin.ee/9JVODFH">LINE</Link><br />
                        メール：contact＠ourt-ai.work<br />
                    </td></tr>
                    <tr><th>業種</th><td>情報通信業</td></tr>
                    <tr><th>事業内容</th><td>
                        先端技術を活用したサービスの開発と付随する一切の業務<br />
                        <ul>
                            <li>作品投稿サイト企画・開発・運営</li>
                            <li>クリエイター支援事業</li>
                            <li>AIチャットボット開発</li>
                            <li>AI画像生成モデル開発</li>
                        </ul>
                    </td></tr>
                    <tr><th>沿革</th><td>
                        <ul>
                            <li><span style={{width:"130px",display:"inline-block"}}>2019年</span> PC修理販売・Web広告事業を個人事業として創業</li>
                            <li><span style={{width:"130px",display:"inline-block"}}>2022年8月24日</span> <Link to={"https://ourt.work/"}>イラスト投稿サイト「アワート」</Link>を開設</li>
                            <li><span style={{width:"130px",display:"inline-block"}}>2022年12月20日</span> <Link to={"https://ourt-ai.work/"}>AIイラスト投稿サイト「アワートAI」</Link>を分離開設</li>
                            <li><span style={{width:"130px",display:"inline-block"}}>2023年7月2日</span> <Link to={"https://sns.ourt-ai.work/"}>AIイラストコミュニティ</Link>を開設</li>
                            <li><span style={{width:"130px",display:"inline-block"}}>2024年1月24日</span> 法人化</li>
                        </ul>
                    </td></tr>
                </tbody>
            </Table>
            <div style={{backgroundColor:"#FFFFFF",padding:"10px"}}>
                <h3 style={{fontWeight:"normal",fontFamily:"Meityo UI"}} className='mb-3'>運営方針</h3>
                <p style={{lineHeight:"30px"}}>
                    アワートAIは、生成AIの活用をサービスを通して普及・利用促進を目指しています。<br />
                    AIにはまだまだ課題や問題点などがありますが、もっと様々な観点から求められるものを考えてサービス展開します。<br />
                    また、今後AIの活用によりいっそう個人のクリエイターの活躍が期待される中で、クリエイター支援にも注力していきます。<br />

                    将来的には文章、音声、動画その他のコンテンツ事業をはじめ、挑戦することを恐れず幅広く展開していきます。<br />
                </p>
                <h3 style={{fontWeight:"normal",fontFamily:"Meityo UI"}} className='mt-3 mb-3'>ニュース</h3>
                <ul style={{fontSize:"20px"}}>
                    <li className='mb-3'>
                        <Link style={{textDecoration:"none"}} to={"https://prtimes.jp/main/html/rd/p/000000003.000122058.html"} className='d-flex'>
                            <div><Image width={60} src='https://prcdn.freetls.fastly.net/release_image/122058/3/122058-3-5ee72a25e087845ee46586465b3c4f88-650x325.png?width=1950&height=1350&quality=85&format=jpeg&auto=webp&fit=bounds&bg-color=fff' style={{borderRadius:"10px"}} /></div>
                            <div style={{marginLeft:"10px"}}><span>2024年6月19日</span><br />AIイラスト投稿サイト「アワートAI」法人化！メンバーシップ機能やクリエイター支援制度などの収益化機能や、画像生成機能を搭載</div>
                        </Link>
                    </li>
                    <li className='mb-3'>
                        <Link style={{textDecoration:"none"}} to={"https://prtimes.jp/main/html/rd/p/000000002.000122058.html"} className='d-flex'>
                            <div><Image width={60} src='https://prcdn.freetls.fastly.net/release_image/122058/2/122058-2-11f7a0baa947b3092ca99fafde938685-1048x1056.png?format=jpeg&auto=webp&quality=85%2C65&width=1950&height=1350&fit=bounds' style={{borderRadius:"10px"}} /></div>
                            <div style={{marginLeft:"10px"}}><span>2023年10月23日</span><br />AIイラスト投稿サイト「アワートAI」、動物イラストコンテスト開催</div>
                        </Link>
                    </li>
                    <li>
                        <Link style={{textDecoration:"none"}} to={"https://prtimes.jp/main/html/rd/p/000000001.000122058.html"} className='d-flex'>
                            <div><Image width={60} src='https://prcdn.freetls.fastly.net/release_image/122058/1/122058-1-1b8da349330a8d48d674f0662caaed0f-1152x1152.jpg?format=jpeg&auto=webp&quality=85%2C65&width=1950&height=1350&fit=bounds' style={{borderRadius:"10px"}} /></div>
                            <div style={{marginLeft:"10px"}}><span>2023年10月17日</span><br />AIイラスト投稿サイト「アワートAI」無料で生成回数無制限モードを追加</div>
                        </Link>
                    </li>
                </ul>
            </div>
        </Container>
        <Footer />
    </div>
    )
}

export default Company;
